
import { useState, useEffect } from 'react';
import './factoryform.css';
import { useNavigate } from 'react-router-dom';


import moment from 'moment';

function FactoryForm() {
    const navigate = useNavigate();
    const [employees, setEmployees] = useState([]);
    const [factories, setFactories] = useState([]);
    const [formData, setFormData] = useState({
        empid1: '',
        empid2: '',
        empid3: '',
        date: '',
        time: '',
        quantity: '',
        bagqty: '',
        water: 0,
        tare: 0,
        netweight: 0,
        stick: 0,
        price: 1,
        totalamount: 0,
        description: '',
        factoryname: '',
        farea: ''
    });

    // Fetch employees and set empid3 from localStorage
    useEffect(() => {
        const fetchEmployees = async () => {
            try {
                const res = await fetch('https://kmtea.onrender.com/employee');
                const data = await res.json();
                if (Array.isArray(data)) {
                    setEmployees(data);
                    const storedEmployee = JSON.parse(localStorage.getItem('user'));
                    const storedEmpid = storedEmployee?.empids?.[0] || '';
                    const formattedDate = new Date().toISOString().split('T')[0];

                    setFormData(prev => ({
                        ...prev,
                        empid3: storedEmpid,
                        date: formattedDate
                    }));
                }
            } catch (err) {
                console.error("Error fetching employees:", err);
            }
        };

        fetchEmployees();
    }, []);

    // Fetch factories
    useEffect(() => {
        const fetchFactories = async () => {
            try {
                const res = await fetch('https://kmtea.onrender.com/factoryinfo');
                const data = await res.json();
                if (Array.isArray(data)) {
                    setFactories(data);
                }
            } catch (err) {
                console.error('Error fetching factory info:', err);
            }
        };

        fetchFactories();
    }, []);

    // Calculate netweight and total amount
    useEffect(() => {
        const quantity = parseFloat(formData.quantity) || 0;
        const water = parseFloat(formData.water) || 0;
        const tarep = parseFloat(formData.tare) || 0;
        const stick = parseFloat(formData.stick) || 0;
        const price = parseFloat(formData.price) || 0;

        const netweight = quantity - (water + tarep + stick);
        const totalamount = netweight * price;

        setFormData(prev => ({
            ...prev,
            netweight: netweight.toFixed(2),
            totalamount: totalamount.toFixed(2)
        }));
    }, [formData.quantity, formData.water, formData.tare, formData.stick, formData.price]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleEmpid1Change = (e) => {
        const selectedEmpId = e.target.value;
        const updatedFormData = { ...formData, empid1: selectedEmpId };
        setFormData(updatedFormData);
        const empids = [selectedEmpId, updatedFormData.empid2, updatedFormData.empid3].filter(Boolean);
        localStorage.setItem('employee', JSON.stringify({ empids }));
    };

    const handleEmpid2Change = (e) => {
        const selectedEmpId = e.target.value;
        const updatedFormData = { ...formData, empid2: selectedEmpId };
        setFormData(updatedFormData);
        const empids = [updatedFormData.empid1, selectedEmpId, updatedFormData.empid3].filter(Boolean);
        localStorage.setItem('employee', JSON.stringify({ empids }));
    };

    const handleFactoryChange = (e) => {
        const selectedFname = e.target.value;
        const selectedFactory = factories.find(f => f.fname === selectedFname);
        setFormData(prev => ({
            ...prev,
            factoryname: selectedFname,
            farea: selectedFactory?.farea || ''
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const empids = [formData.empid1, formData.empid2, formData.empid3].filter(Boolean);
        const now = new Date();
        const formattedTime = moment(now).format('HH:mm:ss');

        const payload = {
            empids,
            date: formData.date,
            time: formattedTime,
            quantity: formData.quantity,
            bagqty: formData.bagqty,
            water: formData.water,
            tare: formData.tare,
            stick: formData.stick,
            price: formData.price,
            netweight: formData.netweight,
            totalamount: formData.totalamount,
            description: formData.description,
            factoryname: formData.factoryname,  // factory name sent as fname
        };

        try {
            const res = await fetch('https://kmtea.onrender.com/api/factory', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload)
            });
            const data = await res.json();
            if (data.success) {
                alert('Factory data submitted successfully!');
              
    navigate('/factorybill', { state: { formData: payload } });
                setFormData(prev => ({
                    ...prev,
                    empid1: '',
                    empid2: '',
                
                    quantity: '',
                    bagqty: '',
                    water: '',
                    tare: '0',
                    stick: '',
                    // price: '',
                    // netweight: '',
                    // totalamount: '',
                    description: '',
                    factoryname: '',
                    farea: ''
                }));
            } else {
                alert('Error: ' + data.message);
            }
        } catch (err) {
            console.error('Submit error:', err);
            alert('Server error occurred');
        }

 
    };

    return (
        <div className="fffff">
            <div className="factory-form-container">
                <form onSubmit={handleSubmit} className="factory-form-form">
                    <h2 className='factory'>Factory Entry</h2>
                    <br />

                    {/* Factory Dropdown & Area */}
                    <div className="factory-form-row">
                        <div>
                            <label>Factory Name</label>
                            <select
                                name="factoryname"
                                value={formData.factoryname}
                                onChange={handleFactoryChange}
                                style={{ backgroundColor: "transparent", height: '40px', borderRadius: '10px', color: 'white' }}
                            >
                                <option style={{ backgroundColor: 'lightblue', color: 'black' }} value="">-- Select Factory --</option>
                                {factories.map(f => (
                                    <option key={f.id} value={f.fname} style={{ backgroundColor: 'lightblue', color: 'black' }}>
                                        {f.fname}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label>Factory Area</label>
                            <input
                                type="text"
                                name="farea"
                                value={formData.farea}
                                readOnly
                                style={{ backgroundColor: "transparent", color: 'white', borderRadius: '10px', height: '20px' }}
                            />
                        </div>
                    </div>

                    {/* Employee Row */}
                    <div className="factory-form-row">
                        <div>
                            <label>Employee 2</label>
                            <select name="empid1" value={formData.empid1} onChange={handleEmpid1Change}
                                style={{ backgroundColor: "transparent", height: '40px', borderRadius: '10px', color: 'white' }}>
                                <option style={{ backgroundColor: 'lightblue', color: 'black' }} value="">-- Select --</option>
                                {employees.map(emp => (
                                    <option key={emp.empid} value={emp.empid} style={{ backgroundColor: 'lightblue', color: 'black' }}>
                                        {emp.empname} ({emp.empid})
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div>
                            <label>Employee 3</label>
                            <select name="empid2" value={formData.empid2} onChange={handleEmpid2Change}
                                style={{ backgroundColor: "transparent", height: '40px', borderRadius: '10px', color: 'white' }}>
                                <option style={{ backgroundColor: 'lightblue', color: 'black' }} value="">-- Optional --</option>
                                {employees.map(emp => (
                                    <option key={emp.empid} value={emp.empid} style={{ backgroundColor: 'lightblue', color: 'black' }}>
                                        {emp.empname} ({emp.empid})
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>

                    {/* Date, Bag Qty, Quantity */}
                    <div className="factory-form-row">
                        <div>
                            <label>Date</label>
                            <input type="date" name="date" value={formData.date} onChange={handleChange} />
                        </div>
                        <div>
                            <label>No of Bags</label>
                            <input type="number" name="bagqty" value={formData.bagqty} onChange={handleChange} required />
                        </div>
                        <div>
                            <label>Quantity (Kg)</label>
                            <input type="number" name="quantity" value={formData.quantity} onChange={handleChange} required />
                        </div>
                    </div>

                    {/* Water, Stick, Tare */}
                    <div className="factory-form-row">
                        <div>
                            <label>Water (Kg)</label>
                            <input type="number" name="water" value={formData.water} onChange={handleChange} required />
                        </div>
                        <div>
                            <label>Stick (Kg)</label>
                            <input type="number" name="stick" value={formData.stick} onChange={handleChange} required />
                        </div>
                        <div>
                            <label>Tare (Kg)</label>
                            <input type="number" name="tare" value={formData.tare} onChange={handleChange} required />
                        </div>
                    </div>

                    {/* Net Weight, Description */}
                    <div className="factory-form-row">
                        <div>
                            <label>Net Weight (Kg)</label>
                            <input type="text" name="netweight" value={formData.netweight} readOnly />
                        </div>
                          <div >
                            <label>TC</label>
                            <input name="netweight" value={formData.netweight} onChange={handleChange} />
                        </div>
                        <div >
                            <label>Description</label>
                            <input name="description" value={formData.description} onChange={handleChange} />
                        </div>
                    </div>

                    {/* Submit */}
                    <button type="submit" className="factory-form-submit-button">Submit</button>
                </form>
            </div>
        </div>
    );
}

export default FactoryForm;
